{
    "name": "reports-app",
    "version": "1.0.25223.10",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build": "ng build",
        "watch": "ng build --watch --configuration development",
        "development-environment-build": "ng build --configuration development --aot",
        "production-environment-build": "ng build --configuration production --aot",
        "test": "ng test"
    },
    "private": true,
    "dependencies": {
        "@angular/cdk": "^19.2.19",
        "@angular/common": "^19.2.14",
        "@angular/compiler": "^19.2.0",
        "@angular/core": "^19.2.0",
        "@angular/forms": "^19.2.0",
        "@angular/platform-browser": "^19.2.0",
        "@angular/platform-browser-dynamic": "^19.2.0",
        "@angular/router": "^19.2.0",
        "@auth0/auth0-angular": "^2.2.3",
        "@primeng/themes": "^20.0.1",
        "ag-grid-angular": "^34.1.1",
        "ag-grid-enterprise": "^34.1.1",
        "primeicons": "^7.0.0",
        "primeng": "^19.0.1",
        "rxjs": "~7.8.0",
        "tslib": "^2.3.0",
        "zone.js": "~0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^19.2.8",
        "@angular/cli": "^19.2.0",
        "@angular/compiler-cli": "^19.2.0",
        "@types/jasmine": "~5.1.0",
        "jasmine-core": "~5.6.0",
        "karma": "~6.4.0",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "~2.2.0",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "typescript": "~5.7.2"
    }
}
